export enum FeatureToggle {
    ShowProjectAndActivitiesInPlanbord = '1850_ShowProjectAndActivitiesInPlanbord',
    EnableWorkSchedule = '4808_EnableWorkSchedule',
    AllowRosterActionsForAnyWeekDay = '5596_RosterActionsToAnyWeekDay',
}
